<template>
  <div>
    <el-dialog
        :title="'Tạo ngày nghỉ chủ nhật'"
        :visible.sync="showCreateDayOffDialog"
        width="600px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="10vh"
    >
      <div>
        <el-row>
          <el-col :span="2">
            <el-date-picker
                style="width: 150px"
                size="medium"
                v-model="dataInput.year"
                type="year"
                value-format="yyyy"
                format="yyyy"
                placeholder="Chọn năm"
                :clearable="false"
            ></el-date-picker>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="2">
            <el-button
                size="small"
                :loading="buttonLoading"
                @click="createDayOffOneAdminManual()"
                type="primary"
            >Tạo ngày nghỉ
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OtherService from "@/services/CommonService/OtherService";

export default {
  props: {
    showCreateDayOffDialog: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      dataInput: {
        year: "",
      },
      buttonLoading: false,
    };
  },

  methods: {
    closeDialog() {
      this.dataInput.year = "";
      this.buttonLoading = false
      this.$emit('close', false);
    },
    createDayOffOneAdminManual() {
      if (this.dataInput.year === "") {
        this.$message({
          message: "Chọn năm khởi tạo",
          type: "error",
        });
        return
      }
      this.$confirm(
          "Bạn có chắc chắn muốn tạo ngày nghỉ chủ nhật không?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      ).then(async () => {
        this.buttonLoading = true;
        let data = {
          year: Number(this.dataInput.year)
        }
        await OtherService.createDayOffClassSunday(data)
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.buttonLoading = false;
              }, 1000);
            });
      });
    },

  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__title {
  font-size: 25px;
  color: #606266;
}
</style>
